<template>
  <div class="business-card-page">
    <h1 class="heading--large">
      Business Card View
    </h1>
    <CalicoBusinessCard
      v-for="(business, index) in businesses"
      :key="index"
      v-model="selectedBusiness"
      :value="business.id"
      :title="business.title"
      :description="business.type"
      :state="business.state"
      :address="business.street"
      :image="business.image"
      :zip="business.zip"
      :non-operating="business.nonOperating"
      :disabled="business.disabled"
      :non-operating-text="business.nonOperatingText"
    />
    <p class="selected-business">
      Selected Business: {{ selectedBusiness }}
    </p>
  </div>
</template>

<script>
import CalicoBusinessCard from "@/components/calico/businessCard/index.vue";

export default {
  name: "BusinessCardPageView",
  components: {
    CalicoBusinessCard,
  },
  data() {
    return {
      selectedBusiness: null,
      businesses: [
        {
          id: 1,
          title: "Betty's Place",
          type: "Coffee store",
          state: "California",
          street: "123 Main St.",
          disabled: false,
          nonOperating: true,
          nonOperatingText: 'not operating',
          zip: 'AZ 85001'
        },
        {
          id: 2,
          title: "Tech Solutions",
          type: "Tech Store",
          state: "California",
          street: "123 Main St.",
          disabled: false,
          nonOperating: false,
          image: "https://placehold.co/150x150",
          zip: 'AZ 85001'
        },
        {
          id: 3,
          title: "Mountain Retreat",
          type: "Mountain store",
          state: "California",
          street: "123 Main St.",
          disabled: true,
          nonOperating: true,
          nonOperatingText: 'not operating',
          image: "https://placehold.co/150x150",
          zip: 'AZ 85001'
        },
      ],
    };
  },
};
</script>

<style lang="scss">
.business-card-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding: 40px;

  .selected-business {
    font-weight: bold;
    margin-top: 20px;
  }
}
</style>